<template>
  <!-- edit Modal -->
  <div
    class="modal fade"
    id="image-alt"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header py-3">
          <h5 class="modal-title">
            <strong>Preview</strong>
          </h5>
          <button @click="closeModal()" type="button" aria-label="Close" class="close">
            <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="px-3">
            <img id="preview-modal-image" :src="img" class="w-100" />
          </div>
          <div class="mt-3 px-3">
            <span>{{ sliceString(img) }}</span>
            <span v v-if="width != 0 && height != 0"> • {{ width }} × {{ height }}</span>
            <a :href="img" v-text="' • Download'" @click.prevent="downloadItem(img, sliceString(img))" />
          </div>
          <form class="px-3" @submit.prevent="">
            <div class="form-group text-center mt-3">
              <button type="button" @click="closeModal" class="btn btn-white btn-sm m-2" style="width: 150px">
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "PhotoPreviewModal",
  props: {
    img: String,
    width: Number,
    height: Number,
  },
  data() {
    return {};
  },

  mounted() {
    console.log('PhotoPreviewModal props:', {
      img: this.img,
      width: this.width,
      height: this.height
    });
  },

  methods: {
    sliceString(value) {
      return value.substring(value.lastIndexOf("/") + 1);
    },

    downloadItem(url, label) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },

    closeModal() {
      $("#image-alt").modal("hide");
      //   this.width = "";
      //   this.height = "";
    },
  },
};
</script>